// import React from "react";
// import PolicyPage from "../../components/PolicyPage/PolicyPage";
// import disclaimerData from "./disclaimerData";

// export default function Disclaimer() {
//   return <PolicyPage data={disclaimerData} />;
// }




import React from "react";
import { Helmet } from "react-helmet-async";
import PolicyPage from "../../components/PolicyPage/PolicyPage";
import disclaimerData from "./disclaimerData";

export default function Disclaimer() {
  return (
    <>
      <Helmet>
        <title>Website Disclaimer | Astro Logical Solutions</title>

        <meta
          name="description"
          content="Read the website disclaimer of Astro Logical Solutions to understand the limitations, accuracy of information and terms governing website content."
        />

        <link
          rel="canonical"
          href="https://astrologicalsolutions.in/website-disclaimer"
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />

        <meta
          property="og:title"
          content="Website Disclaimer | Astro Logical Solutions"
        />

        <meta
          property="og:description"
          content="Understand the website content, information limitations and disclaimer of Astro Logical Solutions."
        />

        <meta
          property="og:url"
          content="https://astrologicalsolutions.in/website-disclaimer"
        />

        <meta
          property="og:site_name"
          content="Astro Logical Solutions"
        />

        {/* Twitter Card */}
        <meta
          name="twitter:card"
          content="summary"
        />

        <meta
          name="twitter:title"
          content="Website Disclaimer | Astro Logical Solutions"
        />

        <meta
          name="twitter:description"
          content="Read the website disclaimer and information limitations of Astro Logical Solutions."
        />
      </Helmet>

      <PolicyPage data={disclaimerData} />
    </>
  );
}
